/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
document.addEventListener("DOMContentLoaded", function () {
    // Hacer que collection__nav se quede fijo debajo del header
    var collectionNav = document.querySelector('.collection__nav');
    var themeHeader = document.querySelector('.theme__header');
    var headerWrapper = document.querySelector('[data-header-wrapper]') || document.querySelector('.header-sections');
    
    if (collectionNav && themeHeader) {
      var navOriginalTop = 0;
      var isNavFixed = false;
      var navHeight = 0;
      
      function calculateNavOriginalTop() {
        if (collectionNav) {
          var rect = collectionNav.getBoundingClientRect();
          navOriginalTop = rect.top + window.pageYOffset;
          navHeight = collectionNav.offsetHeight;
        }
      }
      
      function updateCollectionNavPosition() {
        if (!collectionNav) return;
        
        var headerHeight = 0;
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        // Calcular la altura del header
        if (headerWrapper) {
          headerHeight = headerWrapper.offsetHeight;
        } else if (themeHeader) {
          headerHeight = themeHeader.offsetHeight;
        }
        
        // Usar la variable CSS como respaldo
        var headerHeightCSS = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        if (headerHeightCSS && headerHeightCSS.trim() !== '') {
          var cssHeight = parseInt(headerHeightCSS);
          if (!isNaN(cssHeight) && cssHeight > 0) {
            headerHeight = cssHeight;
          }
        }
        
        // Si no tenemos altura, usar un valor por defecto
        if (headerHeight === 0) {
          headerHeight = 80;
        }
        
        // Calcular la posición original si no la tenemos
        if (navOriginalTop === 0) {
          calculateNavOriginalTop();
        }
        
        // Si el scroll ha pasado la posición original del nav menos la altura del header, hacerlo fixed
        var threshold = navOriginalTop - headerHeight;
        
        if (scrollTop >= threshold) {
          if (!isNavFixed) {
            isNavFixed = true;
            collectionNav.style.position = 'fixed';
            collectionNav.style.top = headerHeight + 'px';
            collectionNav.style.left = '0';
            collectionNav.style.right = '0';
            collectionNav.style.width = '100%';
            collectionNav.style.zIndex = '100';
            
            // Obtener el color de fondo
            var bgColor = getComputedStyle(collectionNav).backgroundColor;
            if (!bgColor || bgColor === 'rgba(0, 0, 0, 0)' || bgColor === 'transparent') {
              bgColor = getComputedStyle(document.body).getPropertyValue('--COLOR-BG') || '#ffffff';
            }
            collectionNav.style.backgroundColor = bgColor;
          } else {
            // Actualizar el top si el header cambia de tamaño
            collectionNav.style.top = headerHeight + 'px';
          }
        } else {
          if (isNavFixed) {
            isNavFixed = false;
            collectionNav.style.position = '';
            collectionNav.style.top = '';
            collectionNav.style.left = '';
            collectionNav.style.right = '';
            collectionNav.style.width = '';
            collectionNav.style.zIndex = '';
          }
        }
      }
      
      // Actualizar en scroll y resize
      var scrollHandler = function() {
        updateCollectionNavPosition();
      };
      var resizeHandler = function() {
        calculateNavOriginalTop();
        updateCollectionNavPosition();
      };
      
      window.addEventListener('scroll', scrollHandler, { passive: true });
      window.addEventListener('resize', resizeHandler);
      
      // Observar cambios en el header (por si cambia de tamaño)
      if (themeHeader) {
        var headerObserver = new MutationObserver(function() {
          updateCollectionNavPosition();
        });
        
        headerObserver.observe(themeHeader, {
          attributes: true,
          attributeFilter: ['class', 'style'],
          childList: false,
          subtree: false
        });
      }
      
      // Ejecutar varias veces para asegurar que se aplique
      setTimeout(function() {
        calculateNavOriginalTop();
        updateCollectionNavPosition();
      }, 100);
      setTimeout(function() {
        calculateNavOriginalTop();
        updateCollectionNavPosition();
      }, 300);
      setTimeout(function() {
        calculateNavOriginalTop();
        updateCollectionNavPosition();
      }, 500);
      setTimeout(function() {
        calculateNavOriginalTop();
        updateCollectionNavPosition();
      }, 1000);
    }
});

// Establecer el atributo 'channel' en el carrito automáticamente
document.addEventListener("DOMContentLoaded", function () {
  // Solo establecer el atributo si el carrito tiene items
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Verificar si el atributo 'channel' ya existe
      if (!cart.attributes || !cart.attributes.channel) {
        // Establecer el atributo 'channel' en el carrito
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              channel: 'online_store'
            }
          })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Cart attribute "channel" set to "online_store"');
        })
        .catch(error => {
          console.error('Error setting cart attribute:', error);
        });
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
});


  



  // ==========================================================================
  // Gift Note: checkbox + from / to / message con caché localStorage + AJAX
  // ==========================================================================
  (function initGiftNote() {
    const CACHE_KEY  = 'mim_gift_note';
    const DEBOUNCE_MS = 600;

    function debounce(fn, delay) {
      let timer;
      return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    }

    function readCache() {
      try { return JSON.parse(localStorage.getItem(CACHE_KEY)) || {}; }
      catch (e) { return {}; }
    }

    function writeCache(data) {
      try { localStorage.setItem(CACHE_KEY, JSON.stringify(data)); }
      catch (e) {}
    }

    function collectValues(widget) {
      const checkEl = widget.querySelector('[data-gift-check]');
      const result  = { 'gift-check': checkEl && checkEl.checked ? 'true' : 'false' };
      widget.querySelectorAll('[data-gift-input]').forEach(el => {
        result[el.dataset.giftInput] = el.value.trim();
      });
      return result;
    }

    const debouncedCartSave = debounce(async function (attributes) {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes }),
        });
      } catch (e) {
        console.warn('[GiftNote] AJAX save failed', e);
      }
    }, DEBOUNCE_MS);

    // Almacena widgets ya inicializados para no duplicar listeners
    const initialized = new WeakSet();

    function initWidget(widget) {
      if (initialized.has(widget)) return;
      initialized.add(widget);

      const checkEl   = widget.querySelector('[data-gift-check]');
      const hiddenEl  = widget.querySelector('[data-gift-hidden="gift-check"]');
      const fieldsEl  = widget.querySelector('[data-gift-fields]');
      const inputEls  = widget.querySelectorAll('[data-gift-input]');

      if (!checkEl || !fieldsEl) return;

      // Prefill desde caché solo si el carrito llega vacío (hiddenEl.value == 'false')
      const cache      = readCache();
      const cartChecked = hiddenEl ? hiddenEl.value === 'true' : false;

      if (!cartChecked && cache['gift-check'] === 'true') {
        checkEl.checked = true;
        if (hiddenEl) hiddenEl.value = 'true';
        fieldsEl.style.display = '';
      }

      inputEls.forEach(el => {
        const key = el.dataset.giftInput;
        if (!el.value && cache[key]) el.value = cache[key];
      });

      // Checkbox change
      checkEl.addEventListener('change', () => {
        const checked = checkEl.checked;
        if (hiddenEl) hiddenEl.value = checked ? 'true' : 'false';
        fieldsEl.style.display = checked ? '' : 'none';
        const vals = collectValues(widget);
        writeCache(vals);
        debouncedCartSave(vals);
      });

      // Inputs / textarea change
      const handleInput = debounce(() => {
        const vals = collectValues(widget);
        writeCache(vals);
        debouncedCartSave(vals);
      }, DEBOUNCE_MS);

      inputEls.forEach(el => {
        el.addEventListener('input', handleInput);
        el.addEventListener('change', handleInput);
      });
    }

    function bootstrap() {
      document.querySelectorAll('[data-gift-note-widget]').forEach(initWidget);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootstrap);
    } else {
      bootstrap();
    }

    // Re-init al abrir el cart drawer (eventos del tema Broadcast)
    document.addEventListener('cart:open', bootstrap);
    document.addEventListener('drawerOpen', bootstrap);

    // MutationObserver: captura el snippet si se inyecta dinámicamente
    new MutationObserver(mutations => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches('[data-gift-note-widget]')) {
            initWidget(node);
          } else {
            node.querySelectorAll('[data-gift-note-widget]').forEach(initWidget);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  })();

  // Preventa por variante (metafield custom.pre_venta): actualiza aviso y texto del botón al cambiar de variante
  document.addEventListener('theme:variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    var source = null;

    document.querySelectorAll('[data-preventa-variants]').forEach(function (el) {
      if (!source && event.target.contains && event.target.contains(el)) source = el;
    });
    if (!source && variant) {
      document.querySelectorAll('[data-preventa-variants]').forEach(function (el) {
        if (!source && (',' + el.dataset.preventaVariants).indexOf(',' + variant.id + ':') !== -1) source = el;
      });
    }
    if (!source) return;

    var productId = source.dataset.preventaProduct;
    var type = '';
    if (variant) {
      source.dataset.preventaVariants.split(',').forEach(function (pair) {
        var parts = pair.split(':');
        if (parts[0] === String(variant.id)) type = parts[1];
      });
    }

    document.querySelectorAll('[data-preventa-notice][data-preventa-product="' + productId + '"]').forEach(function (el) {
      el.hidden = el.dataset.preventaNotice !== type;
    });

    // El tema ya ha restaurado el texto por defecto; solo lo sobrescribimos si la variante está en preventa
    if (type) {
      document.querySelectorAll('[data-preventa-text][data-preventa-product="' + productId + '"]').forEach(function (el) {
        el.innerHTML = theme.strings.preOrder;
      });
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
